<template>

    <div class="tiles" :class="classes">
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .tiles {
        display: grid;
        grid-gap: 15px;
        &.columns-1 {
            grid-template-columns: 1fr;
        }
        &.columns-2 {
            grid-template-columns: 1fr 1fr;
        }
        &.columns-3 {
            grid-template-columns: 1fr 1fr 1fr;
        }
        &.columns-4 {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }
    }

</style>

<script>

export default {

    props: {
        columns: {
            type: Number,
            default: 3,
        },
    },

    computed: {

        classes() {
            return {
                'columns-1': this.columns === 1,
                'columns-2': this.columns === 2,
                'columns-3': this.columns === 3,
                'columns-4': this.columns === 4,
            }
        },

    },

}

</script>
